import React from 'react';
import PropTypes from 'prop-types';

/**
 * The component provides state for confirmation modals
 */
class ConfirmContainer extends React.Component {
  static propTypes = {
    children: PropTypes.func
  };

  state = {
    isOpen: false
  };

  toggleIsOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    return this.props.children(this.state.isOpen, this.toggleIsOpen);
  }
}

export default ConfirmContainer;
